let bodyLockStatus = true

export function bodyLockToggle(delay = 300) {
  if (document.documentElement.classList.contains('lock')) {
    bodyUnlock(delay)
  } else {
    bodyLock(delay)
  }
}

export function bodyUnlock(delay = 300) {
  const body = document.querySelector('body')
  if (bodyLockStatus) {
    const lockPadding = document.querySelectorAll('[data-lp]')
    setTimeout(() => {
      lockPadding.forEach(el => {
        el.style.paddingRight = '0px'
      })
      body.style.paddingRight = '0px'
      document.documentElement.classList.remove('lock')
    }, delay)

    bodyLockStatus = false
    setTimeout(() => {
      bodyLockStatus = true
    }, delay)
  }
}

export function bodyLock(delay = 300) {
  const body = document.querySelector('body')
  if (bodyLockStatus) {
    const lockPadding = document.querySelectorAll('[data-lp]')
    const paddingOffset = window.innerWidth - document.querySelector('.wrapper').offsetWidth + 'px'

    lockPadding.forEach(el => {
      el.style.paddingRight = paddingOffset
    })
    body.style.paddingRight = paddingOffset
    document.documentElement.classList.add('lock')

    bodyLockStatus = false
    setTimeout(() => {
      bodyLockStatus = true
    }, delay)
  }
}
